import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrText from 'client/components/SrText';

export const SR_STEPPER_THEME_GREYCLIFF = 'SR_STEPPER_THEME_GREYCLIFF';
const SR_STEPPER_THEME_TO_CLASSNAME_MAPPING = {
  [SR_STEPPER_THEME_GREYCLIFF]: 'greycliff',
};

const SrStepper = ({ theme, steps, activeStep, showNumberStep }) => {
  return (
    <div className={classnames('SrStepper', SR_STEPPER_THEME_TO_CLASSNAME_MAPPING[theme])}>
      {steps.map((step, stepIndex) => {
        const isComplete = stepIndex < activeStep;
        const isActive = stepIndex === activeStep;
        return (
          // eslint-disable-next-line react/no-array-index-key
          <div key={stepIndex} className="stepWrapper">
            <div className={classnames('step', { isActive: isActive, isComplete: isComplete })}>
              <div className="circle">{showNumberStep && <span>{stepIndex + 1}</span>}</div>
              <SrText
                weight="bold"
                color={isActive || isComplete ? 'blue' : 'grey600'}
                className="text"
              >
                {step.title}
              </SrText>
              {stepIndex !== 0 && <div className="line" />}
            </div>
          </div>
        );
      })}
    </div>
  );
};

SrStepper.defaultProps = {
  activeStep: 0,
};

SrStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
    }),
  ).isRequired,
  activeStep: PropTypes.number,
  showNumberStep: PropTypes.bool,
};

export default SrStepper;
